import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-2 rounded-full border border-negative/40 bg-negative/10 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-negative",
  "data-testid": "policy-section-activity-request-lock"
}
const _hoisted_2 = ["inert"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-xs text-neutral50 m-0",
  "data-testid": "policy-activity-request-intro"
}, " Quando a perna (check-in ou check-out) fica sem registro, o sistema abre sozinho uma solicitação na fila unificada. Prazo por canal: ", -1)
const _hoisted_4 = {
  key: 0,
  class: "m-0 rounded-md border border-alert bg-[#FDF1DF] px-3 py-2 text-xs font-bold text-alert",
  "data-testid": "policy-activity-request-disabled"
}
const _hoisted_5 = ["data-testid", "onFocusout"]
const _hoisted_6 = { class: "w-full sm:w-[420px]" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "text-xs text-neutral50 m-0" }
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = ["data-testid"]
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = { class: "text-xs text-neutral50" }
const _hoisted_13 = ["data-testid", "onClick"]
const _hoisted_14 = ["data-testid"]
const _hoisted_15 = {
  class: "flex flex-col gap-2",
  "data-testid": "policy-send-window"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 text-sm font-bold text-neutral50" }, "Prazo para enviar", -1)
const _hoisted_17 = {
  class: "m-0 text-xs text-neutral50",
  "data-testid": "policy-send-window-help"
}
const _hoisted_18 = {
  key: 0,
  class: "w-full sm:w-[420px]",
  "data-testid": "policy-send-window-app-input"
}
const _hoisted_19 = {
  key: 1,
  class: "w-full sm:w-[420px]",
  "data-testid": "policy-send-window-sheet-input"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  class: "m-0 text-xs text-neutral50",
  "data-testid": "policy-send-window-sheet-max"
}, " máximo 30 dias ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "rounded-lg border border-neutral80 bg-neutral95/40 px-3 py-2.5",
  "data-testid": "policy-activity-request-cross-cancel"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 text-sm font-bold text-neutral50" }, [
    /*#__PURE__*/_createTextVNode(" Cancelar automaticamente quando outro canal cobrir a perna "),
    /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-[10px] font-extrabold uppercase tracking-wide text-neutral60" }, " fixo — sempre ligado ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 mt-1 text-xs text-neutral50" }, " Folha aprovada, check tardio do app, importação do App Externo ou envio manual da mesma perna encerram a solicitação (status Excluído, com motivo e evento na trilha). A perna coberta some da fila; a outra continua aberta. ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  class: "m-0 text-xs text-neutral50",
  "data-testid": "policy-activity-request-no-notification"
}, " 🔔 Sem notificação push nesta fase. A cobrança é o próprio container na fila de auditoria (“Aguardando envio”) — nada é disparado para o médico no app. ", -1)

import { computed, ref } from 'vue'

import CollapsibleSection from '@/modules/company/Dashboard/components/CollapsibleSection.vue'
import {
  ActivityRequestChannel,
  ACTIVITY_REQUEST_CHANNEL_LABELS,
  ACTIVITY_REQUEST_DEFAULTS,
  ACTIVITY_REQUEST_MAX_DAYS,
  ACTIVITY_REQUEST_MAX_HOURS,
  DSAttendanceMonitoringType,
  DSAttendanceRuleRecurrence,
  isActivityRequestChannelOff
} from '@/constants/ds-attendance.constants'

import {
  APP_SEND_WINDOW_PLACEHOLDER,
  sheetSendWindowPlaceholder
} from './activityRequestSendWindow'

/** Campo do payload que cada canal escreve (§1.5). */
type DelayField =
  | 'requestAfterCheckoutHoursApp'
  | 'requestAfterDaysSheet'
  | 'requestAfterHoursExternal'

interface ChannelRow {
  channel: ActivityRequestChannel
  field: DelayField
  label: string
  unit: string
  help: string
  /** Valor do placeholder quando o prazo é `null` — o default do produto (Q9). */
  fallback: number
  max: number
  value: number | null
  displayValue: string
  editable: boolean
}

/** Canal cujo campo acabou de ficar vazio e espera a confirmação "não cobrar". */

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityRequestSection',
  props: {
    monitoringType: {},
    requestAfterCheckoutHoursApp: { default: null },
    requestAfterDaysSheet: { default: null },
    requestAfterHoursExternal: { default: null },
    requiresAppCheck: { type: Boolean, default: false },
    activityRecordsEnabled: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    errors: { default: () => ({}) },
    sendWindowHoursApp: { default: null },
    sendWindowDaysSheet: { default: null },
    sheetRecurrences: { default: () => [] }
  },
  emits: ["update:requestAfterCheckoutHoursApp", "update:requestAfterDaysSheet", "update:requestAfterHoursExternal", "update:sendWindowHoursApp", "update:sendWindowDaysSheet"],
  setup(__props: any, { emit }) {

const props = __props;





const showAppWindow = computed(
  () =>
    props.monitoringType === DSAttendanceMonitoringType.MINHA_ESCALA_APP ||
    props.monitoringType === DSAttendanceMonitoringType.EXTERNAL_APP
)
const showSheetWindow = computed(
  () =>
    props.monitoringType === DSAttendanceMonitoringType.FOLHA ||
    props.monitoringType === DSAttendanceMonitoringType.NON_DAILY_SHEET
)
/** App e folha são exclusivos: o campo visível decide a unidade do texto de ajuda. */
const sendWindowUnitText = computed(() =>
  showSheetWindow.value ? 'dias corridos' : 'horas corridas'
)
const sheetWindowPlaceholder = computed(() =>
  sheetSendWindowPlaceholder(props.monitoringType, props.sheetRecurrences)
)

/** Vazio = `null` (padrão). Sem confirmação: aqui não existe o "0 = desligar" dos prazos. */
const parseWindow = (raw: unknown): number | null => {
  const text = String(raw ?? '').trim()
  return text === '' ? null : Number(text)
}
const onAppWindowInput = (raw: unknown) => emit('update:sendWindowHoursApp', parseWindow(raw))
const onSheetWindowInput = (raw: unknown) => emit('update:sendWindowDaysSheet', parseWindow(raw))

/**
 * M4-2: o canal cobrado é o da modalidade; App Minha Escala entra JUNTO quando a
 * modalidade é folha E a política exige check do app, porque nesse caso o job usa o
 * MENOR dos dois prazos (§6.2) e esconder o campo deixaria o usuário sem explicação
 * para uma cobrança que chega em 2 h numa escala de folha.
 */
const editableChannels = computed<ActivityRequestChannel[]>(() => {
  switch (props.monitoringType) {
    case DSAttendanceMonitoringType.MINHA_ESCALA_APP:
      return [ActivityRequestChannel.MINHA_ESCALA_APP]
    case DSAttendanceMonitoringType.EXTERNAL_APP:
      return [ActivityRequestChannel.EXTERNAL_APP]
    case DSAttendanceMonitoringType.FOLHA:
    case DSAttendanceMonitoringType.NON_DAILY_SHEET:
      return props.requiresAppCheck
        ? [ActivityRequestChannel.FOLHA, ActivityRequestChannel.MINHA_ESCALA_APP]
        : [ActivityRequestChannel.FOLHA]
    default:
      return []
  }
})

const pendingEmptyChannel = ref<ActivityRequestChannel | null>(null)

const CHANNEL_SPECS = [
  {
    channel: ActivityRequestChannel.MINHA_ESCALA_APP,
    field: 'requestAfterCheckoutHoursApp' as DelayField,
    unit: 'horas',
    help: 'Após o check-out previsto, sem check-out registrado.',
    fallback: ACTIVITY_REQUEST_DEFAULTS.afterCheckoutHoursApp,
    max: ACTIVITY_REQUEST_MAX_HOURS
  },
  {
    channel: ActivityRequestChannel.FOLHA,
    field: 'requestAfterDaysSheet' as DelayField,
    unit: 'dias',
    help: 'Após o plantão, sem vínculo a uma folha.',
    fallback: ACTIVITY_REQUEST_DEFAULTS.afterDaysSheet,
    max: ACTIVITY_REQUEST_MAX_DAYS
  },
  {
    channel: ActivityRequestChannel.EXTERNAL_APP,
    field: 'requestAfterHoursExternal' as DelayField,
    unit: 'horas',
    help: 'Após o check-out previsto, sem registro importado.',
    fallback: ACTIVITY_REQUEST_DEFAULTS.afterHoursExternal,
    max: ACTIVITY_REQUEST_MAX_HOURS
  }
] as const

const valueOf = (field: DelayField): number | null => props[field] ?? null

const channelRows = computed<ChannelRow[]>(() =>
  CHANNEL_SPECS.map((spec) => {
    const value = valueOf(spec.field)
    return {
      ...spec,
      label: ACTIVITY_REQUEST_CHANNEL_LABELS[spec.channel],
      value,
      // Campo em branco enquanto a confirmação está pendente: o usuário apagou e ainda
      // não disse o que isso significa.
      displayValue:
        pendingEmptyChannel.value === spec.channel || value === null ? '' : String(value),
      editable: editableChannels.value.includes(spec.channel)
    }
  })
)

const emitDelay = (field: DelayField, value: number | null) => {
  if (field === 'requestAfterCheckoutHoursApp') emit('update:requestAfterCheckoutHoursApp', value)
  else if (field === 'requestAfterDaysSheet') emit('update:requestAfterDaysSheet', value)
  else emit('update:requestAfterHoursExternal', value)
}

/**
 * Esvaziar o campo NÃO grava nada sozinho. `null` ("usar o default do produto") e `0`
 * ("não cobrar neste canal") são estados diferentes e indistinguíveis a partir de um
 * campo em branco — por isso a confirmação explícita do M4 ③.
 */
const onDelayInput = (row: ChannelRow, raw: unknown) => {
  const text = String(raw ?? '').trim()

  if (text === '') {
    pendingEmptyChannel.value = row.channel
    return
  }

  pendingEmptyChannel.value = null
  const parsed = Number(text)
  emitDelay(row.field, Number.isNaN(parsed) ? null : parsed)
}

const confirmChannelOff = (row: ChannelRow) => {
  pendingEmptyChannel.value = null
  emitDelay(row.field, 0)
}

const cancelChannelOff = () => {
  pendingEmptyChannel.value = null
}

/**
 * Sair da linha sem responder equivale a desistir: o campo volta a mostrar o valor que
 * continua no payload. Antes o input ficava em branco enquanto o prazo antigo seguia gravado,
 * e o usuário salvava "em branco" e via o número voltar.
 *
 * `focusout` na LINHA (e não `blur` no input) porque clicar em "Não cobrar" tira o foco do
 * campo: o `relatedTarget` dentro da própria linha mantém a pergunta de pé.
 */
const onRowFocusOut = (row: ChannelRow, event: FocusEvent) => {
  if (pendingEmptyChannel.value !== row.channel) return

  const next = event.relatedTarget as Node | null
  const container = event.currentTarget as HTMLElement | null
  if (next && container?.contains(next)) return

  pendingEmptyChannel.value = null
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(CollapsibleSection, {
    title: "Solicitação automática de Registro de Atividade",
    "test-id": "policy-activity-request"
  }, {
    "title-prefix": _withCtx(() => [
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 🔒 leitura "))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "flex flex-col gap-5 text-left",
        "data-testid": "policy-activity-request-fields",
        inert: _ctx.readonly || undefined
      }, [
        _hoisted_3,
        (_ctx.activityRecordsEnabled === false)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Registro de Atividade desligado nesta escala: nenhuma solicitação é aberta enquanto o toggle acima estiver desligado. "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelRows.value, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.channel,
            class: _normalizeClass(["flex flex-col gap-1", row.editable ? '' : 'opacity-50']),
            "data-testid": `policy-activity-request-row-${row.channel}`,
            onFocusout: ($event: any) => (onRowFocusOut(row, $event))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                "data-testid": `policy-activity-request-${row.channel}-input`
              }, [
                _createVNode(_component_v_text_field, {
                  "model-value": row.displayValue,
                  label: row.label,
                  placeholder: String(row.fallback),
                  suffix: row.unit,
                  disabled: _ctx.readonly || !row.editable,
                  "error-messages": _ctx.errors[row.field],
                  type: "number",
                  min: "0",
                  max: row.max,
                  variant: "outlined",
                  density: "comfortable",
                  color: "primary20",
                  "persistent-placeholder": "",
                  "onUpdate:modelValue": ($event: any) => (onDelayInput(row, $event))
                }, null, 8, ["model-value", "label", "placeholder", "suffix", "disabled", "error-messages", "max", "onUpdate:modelValue"])
              ], 8, _hoisted_7)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(row.help), 1),
            (_unref(isActivityRequestChannelOff)(row.value))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "text-xs font-bold text-neutral50 m-0",
                  "data-testid": `policy-activity-request-${row.channel}-off`
                }, " Sem solicitação automática por este canal. ", 8, _hoisted_9))
              : _createCommentVNode("", true),
            (!row.editable)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "text-xs text-neutral50 m-0",
                  "data-testid": `policy-activity-request-${row.channel}-inactive`
                }, " Não é a modalidade desta política: nenhuma solicitação é aberta por este canal. ", 8, _hoisted_10))
              : _createCommentVNode("", true),
            (pendingEmptyChannel.value === row.channel)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "flex flex-wrap items-center gap-2 rounded-lg border border-attention/40 bg-attention/5 px-3 py-2",
                  "data-testid": `policy-activity-request-${row.channel}-empty-confirm`,
                  role: "alertdialog",
                  "aria-live": "assertive"
                }, [
                  _createElementVNode("span", _hoisted_12, " Não cobrar neste canal? O prazo em branco não desliga a cobrança sozinho — confirme para gravar 0 e parar de abrir solicitações por “" + _toDisplayString(row.label) + "”. ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "rounded-md bg-primary30 px-3 py-1 text-xs font-bold text-white",
                    "data-testid": `policy-activity-request-${row.channel}-empty-accept`,
                    onClick: ($event: any) => (confirmChannelOff(row))
                  }, " Não cobrar ", 8, _hoisted_13),
                  _createElementVNode("button", {
                    type: "button",
                    class: "rounded-md border border-neutral70 px-3 py-1 text-xs font-bold text-neutral50",
                    "data-testid": `policy-activity-request-${row.channel}-empty-cancel`,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelChannelOff()))
                  }, " Cancelar ", 8, _hoisted_14)
                ], 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 42, _hoisted_5))
        }), 128)),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", _hoisted_17, " Conta a partir da abertura da solicitação, em " + _toDisplayString(sendWindowUnitText.value) + ". Vazio usa o padrão. ", 1),
          (showAppWindow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_v_text_field, {
                  "model-value": _ctx.sendWindowHoursApp ?? '',
                  label: "Prazo para enviar — App (horas)",
                  placeholder: _unref(APP_SEND_WINDOW_PLACEHOLDER),
                  suffix: "horas",
                  type: "number",
                  min: "1",
                  max: "720",
                  disabled: _ctx.readonly,
                  "error-messages": _ctx.errors.activityRequestSendWindowHoursApp,
                  variant: "outlined",
                  density: "comfortable",
                  color: "primary20",
                  "persistent-placeholder": "",
                  "onUpdate:modelValue": onAppWindowInput
                }, null, 8, ["model-value", "placeholder", "disabled", "error-messages"])
              ]))
            : _createCommentVNode("", true),
          (showSheetWindow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_v_text_field, {
                  "model-value": _ctx.sendWindowDaysSheet ?? '',
                  label: "Prazo para enviar — Folha (dias)",
                  placeholder: sheetWindowPlaceholder.value,
                  suffix: "dias",
                  type: "number",
                  min: "1",
                  max: "30",
                  disabled: _ctx.readonly,
                  "error-messages": _ctx.errors.activityRequestSendWindowDaysSheet,
                  variant: "outlined",
                  density: "comfortable",
                  color: "primary20",
                  "persistent-placeholder": "",
                  "onUpdate:modelValue": onSheetWindowInput
                }, null, 8, ["model-value", "placeholder", "disabled", "error-messages"]),
                _hoisted_20
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_21,
        _hoisted_22
      ], 8, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})